import React from 'react'
import logo_light from '../../assets/logo.png';
import logo_dark from '../../assets/logo-dark.png';

export const Logo = ({height, showName = true}) => {
  const defaultHeight = 64;
  const calcHeight = height || defaultHeight;
  const calcFontSize = (calcHeight / 4) < 16 ? 16 : calcHeight / 4;
  return (
    <div className='logo'>
        <img src={logo_light} className='logo__image-light' style={{height: calcHeight + 'px'}} alt="Логотип" />
        <img src={logo_dark} className='logo__image-dark' style={{height: calcHeight + 'px'}} alt="Логотип" />
        {showName && <span style={{fontSize: calcFontSize + 'px'}}>KONTORA</span>}
    </div>
  )
}
